import { render, staticRenderFns } from "./CustomerForm.vue?vue&type=template&id=73d520b2&scoped=true&"
import script from "./CustomerForm.vue?vue&type=script&lang=ts&"
export * from "./CustomerForm.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerForm.vue?vue&type=style&index=0&id=73d520b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d520b2",
  null
  
)

export default component.exports